import React, { forwardRef } from 'react';
import styled from 'styled-components';

interface StyledInputWrapperProps {
  isValid: boolean;
  isSelected: boolean;
}

const InputWrapper = styled.div<StyledInputWrapperProps>`
  height: 2rem;
  line-height: 2rem;
  border: ${({ theme, isValid, isSelected }) =>
    `1px solid ${!isValid && isSelected ? theme.colors.error : theme.colors.inputBorderColor}`};
  border-radius: ${({ theme }) => theme.misc.inputBorderRadius};
  font-size: 1rem;
  transition: all 0.2s ease;
  position: relative;
  display: flex;
  width: 100%;
  // background-color: ${({ theme }) => theme.colors.inputBg};
  background-color: #f7f7f7;
  @media screen and (max-width: 600px) {
    height: 1.75rem;
    div,
    button {
      height: 1.75rem;
    }
    > div {
      font-size: 12px;
      padding: 0.2rem;
    }
  }
`;

const StepButton = styled.button`
  // height: 100%;
  display: inline-flex;
  width: 2rem;
  // align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  border: 0;
  color: ${({ theme }) => theme.colors.primary};
  background-color: #f7f7f7;
  line-height: 100%;
  /* position: absolute;
  top: 0;
  left: 0;
  z-index: 2; */
  padding: 0;
  &:last-of-type {
    /* left: auto;
    right: 0; */
    border-left: ${({ theme }) => `1px solid ${theme.colors.inputBorderColor}`};
  }
  &:first-of-type {
    border-right: ${({ theme }) => `1px solid ${theme.colors.inputBorderColor}`};
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.gray};
  }
`;

const DisplayedNumber = styled.div<DisplayedNumberProps>`
  display: inline-flex;
  // height: 100%;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;
  font-size: 13px;
  color: ${({ theme, $disabled }) => ($disabled ? theme.colors.gray : '#000')};
`;

const Input = styled.input`
  display: none;
  /* display: inline-flex;
  height: 100%;
  min-width: 2rem;
  text-align: center;
  border: 0;
  background: transparent;
  width: 100%;
  padding: 0 1.5rem;
  font-size: 1rem;
  -moz-appearance: textfield;
  box-shadow: none;
  color: ${({ theme }) => theme.colors.text};
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.gray};
  } */
`;

interface DisplayedNumberProps {
  $disabled: boolean;
}

export interface NumberInputProps extends React.HTMLAttributes<HTMLInputElement> {
  isValid: boolean;
  hideLabel?: boolean;
  value?: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  increaseButtonTestId?: string;
  decreaseButtonTestId?: string;
  handleChange: (val: number) => void;
}

const NumberOfInput = forwardRef<HTMLInputElement, NumberInputProps>(
  (
    {
      min = 1,
      max = 10000,
      value = 1,
      hideLabel = false,
      id = '',
      handleChange,
      disabled = false,
      increaseButtonTestId,
      decreaseButtonTestId,
      isValid,
      ...rest
    },
    ref?: React.Ref<HTMLInputElement>,
  ) => {
    const _handleChange = (_value: number) => {
      if (_value >= min && _value <= max) handleChange(_value);
      // onChange(value >= min ? value : min);
    };

    const handleKeyDown = (e: any) => {
      switch (e.keyCode) {
        case 38:
          _handleChange(Number(e.target.value));
          break;
        case 40:
          _handleChange(Number(e.target.value));
          break;
        default:
          break;
      }
    };

    const minButtonDisabled = disabled || value === min;
    const maxButtonDisabled = disabled || value === max;

    return (
      <InputWrapper isValid={isValid} isSelected={!disabled}>
        <StepButton
          disabled={minButtonDisabled}
          data-testid={decreaseButtonTestId}
          onClick={() => _handleChange(value - 1)}
        >
          -
        </StepButton>
        <Input
          id={id}
          type="number"
          min={min}
          max={max}
          value={value}
          disabled={disabled}
          onFocus={(e) => e.target.select()}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            _handleChange(Number(e.target.value));
          }}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => handleKeyDown(e)}
          ref={ref}
          {...rest}
        />
        <DisplayedNumber $disabled={disabled}>{`${value}/${max}`}</DisplayedNumber>
        <StepButton
          disabled={maxButtonDisabled}
          data-testid={increaseButtonTestId}
          onClick={() => _handleChange(Number(value) + 1)}
        >
          +
        </StepButton>
      </InputWrapper>
    );
  },
);

export default NumberOfInput;
